// Module
var code = "<h1 id=\"release-notes-293\">Release notes 2.9.3</h1> <p>Date : 17/08/2021</p> <h4 id=\"nouveautés\">Nouveautés</h4> <ul> <li>Nouvel indicateur &quot;Nombre total d&#39;appareils connectés&quot;</li> </ul> ";
// Exports
export default code;